import React from "react";
import styled from "styled-components";
import { URLPOZE } from "../../utils/constants.ts";

const TileContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  padding: 16px;
  border: 2px solid var(--background-yellow);
  border-radius: 8px;
  justify-content: space-between;
`;

const Image = styled.img`
  background-color: #f0f0f0;
  border: 1px solid var(--background-yellow);
  min-width: 100px;
  width: 100px;
  height: 100px;
`;

const ProductName = styled.p`
  color: var(--secondary-font-color);
  font-size: 1.2rem;
  font-family: Georgia, serif;
  margin: 0;
`;

const UnitPrice = styled.p`
  color: var(--tertiary-font-color);
  font-size: 1rem;
  font-family: Verdana, sans-serif;
`;

const ProductPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const StrikePrice = styled.div`
  font-family: Verdana, sans-serif;
  text-decoration: line-through;
  color: var(--tertiary-font-color);
  font-size: 0.8rem;
`;

interface Props {
  productID: string;
  productName: string;
  price: number;
  image?: string;
  discount?: number;
}

const ResumeProductTile: React.FC<Props> = ({
  productID,
  productName,
  price,
  discount,
  image,
}) => {
  return (
    <TileContainer data-testid="summary-product-tile">
      {image && (
        <Image src={`${URLPOZE}${image}`} alt={`Product ${productID}`} />
      )}

      <div>
        <ProductName>{productName}</ProductName>

        {discount ? (
          <ProductPrice data-testid="product-price">
            <UnitPrice>
              {Number(price) - Number(price) * (Number(discount) / 100)} lei
            </UnitPrice>
            <StrikePrice>{price} lei</StrikePrice>
          </ProductPrice>
        ) : (
          <UnitPrice>
            {price}
            {" lei"}
          </UnitPrice>
        )}
      </div>
    </TileContainer>
  );
};

export default ResumeProductTile;
